var _style, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Better Images") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@font-face {\n  font-family: \"Anton\";\n  src: url(\"data:font/woff2;base64,d09GMgABAAAAAALoAA4AAAAABWQAAAKVAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhQbHhwoBmAAPBEICoE8gUELCAABNgIkAwwEIAWEDAcgG3AEyAQeHj3sRwWY8lzZBwjDUvPtt8Hx4a/JH/AESviUKt4iAj9uTbujGVZYBZ3OmniL7IK1M7gZATDCCAuqJGYNcBL7haSUrCL0kKeSmgZQLNtbhig2WiyoX7EIE80F2S5L94QjKKAEys1i4Fw+WmxmlrSDwNoiktmh+T3BopmrV/BF4G6tP/dfTZ9hlHhNRTg+XlWGdMakrIqk2aKsuLaVBkFkZCYTnUYBEZWEbahiXZvQPgP0Q9Y1DdMaUkp0bD2NBAVLAZBdR5l9iixJkmSub2C43nztulqjNbU1a9dXFVUZG6433t8NW7qKurvF7V0G6wz39wrCVgODtfvVLT0GBuLNHHTGGoxHHK0S7zoU6b78MNE80ex58wLKhfHmhI67DkVM/3r4y6N3vdkbys5W2K5yzhu6fD9Wu33wvF5Repq/Y2bw0+LMDDHo3N5tQ5nTS2Li/+fv4i6Izs9KHrc+qDWN+qZnqjdUG9Q63uV7h3QfPPh38t9Mw4eGETsMiRj6uXb2/jv5d5nhw1MxgmOS9J8cqYscYYzDZhJl6FKHAoPczukx6waisr5cfMTPmhUw4CsrYsIYK+HHE1bGgVOsQgp5rA4OhNgm2nWYwwpWsITlROCLr9bbyDLmsoQVLuPDcnuB6G8xy5iNL7mkkEU8i1jBYs3PDAqYyWxWsoB6llHCTEHBUGbuqQTggz/+hBCJyofOop6VmPk5zKXxv8pkVuGPD2H4EMgU2mKqi5YkznYmq1lB5FY8WgOQxkQWs4S1x8TsC1C2Cb94vUoRc5iJuoVsHstkOo+ZNAIRfwDMuRQsdzyvMT+bubP7VtKAD40sZuFIdjGLJbqAmcyiq1zysC+fYMpI0Ac7OOUvTcX/ZmYRAAAA\") format(\"woff2\");\n}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#4e3bfc",
    cx: 225,
    cy: 225,
    r: 200,
    stroke: "#4e3bfc",
    strokeWidth: 48
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 355,
    fontSize: 300,
    fill: "white",
    fontFamily: "Anton"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f8be71fad21c685ee20fc66cae58e2ca.svg";
export { ForwardRef as ReactComponent };